/* Header navigation (loaded by sections/header.liquid).
 *
 * Shop and Guides mega menus (snippets/mega-menu.liquid)
 *   desktop  hover intent to open / close, "menu aim" so a diagonal move from a
 *            category toward its panel does not switch category, first tap opens
 *            on touch screens, chevron button + arrow keys for keyboard users.
 *   <= 900px the same markup is moved into the menu drawer and shown as panels that
 *            slide in from the right (menu, then category).
 * Shop dropdowns (still toggled by theme.js): the first tap on a touch screen opens
 *   the dropdown instead of following the parent link.
 * Menu drawer (snippets/mobile-menu.liquid, <= 900px): slides in from the left like the
 *   cart drawer, locks the page behind it and puts the reader back where they were on
 *   close; closes on Close, the backdrop, Escape or a swipe to the left.
 */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var desktop = window.matchMedia('(min-width: 901px)');
  var pointer = 'mouse';

  doc.addEventListener('pointerdown', function (e) {
    pointer = e.pointerType || 'mouse';
    root.classList.remove('mnav-kbd');
  }, true);
  doc.addEventListener('keydown', function (e) {
    var k = e.key || '';
    if (k === 'Tab' || k === 'Enter' || k === ' ' || k.indexOf('Arrow') === 0) {
      pointer = 'keyboard';
      root.classList.add('mnav-kbd');
    }
  }, true);

  function touchy() { return pointer === 'touch' || pointer === 'pen'; }
  function onMediaChange(fn) {
    if (desktop.addEventListener) desktop.addEventListener('change', fn);
    else if (desktop.addListener) desktop.addListener(fn);
  }
  function focusQuietly(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  var navEl = doc.getElementById('AccessibleNav');
  function navBottom() {
    var b = navEl ? Math.round(navEl.getBoundingClientRect().bottom) : 0;
    if (b > 0) root.style.setProperty('--maw-nav-bottom', b + 'px');
    return b;
  }

  /* ---------- Shop (theme.js) dropdowns ---------- */
  var siteNav = doc.getElementById('SiteNav');
  if (siteNav) {
    // Capture phase: runs before theme.js's click handler on the <li> adds the open class.
    siteNav.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a.site-nav__link--main') : null;
      if (!a || !a.parentNode.hasAttribute('data-has-dropdowns')) return;
      if (touchy() && !a.parentNode.classList.contains('site-nav--active-dropdown')) e.preventDefault();
    }, true);
    siteNav.addEventListener('pointerover', function () { if (desktop.matches) navBottom(); });
  }

  /* ---------- Menu drawer + mega menus ---------- */
  var megas = [];
  var drawer = initDrawer();
  [].forEach.call(doc.querySelectorAll('.gm[data-mega]'), function (el) {
    if (el.parentNode) megas.push(initMega(el));
  });
  if (megas.length) root.classList.add('gm-js');
  function closeMegas(except) {
    megas.forEach(function (m) { if (m.panel !== except) m.hide(); });
  }

  function initDrawer() {
    var panel = doc.getElementById('MobileNav');
    var overlay = doc.querySelector('[data-mnav-overlay]');
    var toggle = doc.querySelector('.js-mobile-nav-toggle');
    if (!panel || !overlay || !toggle) return null;
    var views = panel.querySelector('[data-mnav-views]');
    var closeBtn = panel.querySelector('[data-mnav-close]');
    var body = doc.body;
    var isOpen = false;
    var savedY = 0;
    var resetTimer = 0;

    // Out of the sticky header's stacking context, so it sits above the page and its widgets.
    body.appendChild(overlay);
    body.appendChild(panel);

    function sync() {
      var deep = false;
      var mega = false;
      for (var v = views.firstElementChild; v; v = v.nextElementSibling) {
        if (!v.classList.contains('is-open')) continue;
        deep = true;
        if (v.hasAttribute('data-mega')) mega = true;
      }
      views.classList.toggle('is-deep', deep);
      panel.classList.toggle('is-mega', mega);
    }
    function setState(on) {
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      panel.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    }
    function scrollPageTo(y) {
      var behavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      root.style.scrollBehavior = behavior;
    }
    // Category thumbnails are loading="lazy"; start them as soon as the drawer opens.
    function warmTiles() {
      [].forEach.call(panel.querySelectorAll('.gm__tile img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    }

    function open() {
      if (isOpen || desktop.matches) return;
      clearTimeout(resetTimer);
      isOpen = true;
      savedY = window.pageYOffset || 0;
      // aria-expanded first: the header's collapse-on-scroll script ignores scrolls while it is "true".
      setState(true);
      body.style.top = -savedY + 'px';
      root.classList.add('maw-nav-open');
      warmTiles();
      setTimeout(function () { if (isOpen) focusQuietly(closeBtn); }, 50);
    }
    function close(instant) {
      if (!isOpen) return;
      isOpen = false;
      setState(false);
      if (instant) {
        panel.classList.add('is-dragging');
        overlay.classList.add('is-dragging');
      }
      root.classList.remove('maw-nav-open', 'mnav-leaving');
      body.style.top = '';
      if (instant) void panel.offsetWidth;
      scrollPageTo(savedY);
      focusQuietly(toggle);
      clearTimeout(resetTimer);
      resetTimer = setTimeout(reset, instant ? 0 : 320);
    }
    // Every open starts at the main list.
    function reset() {
      panel.classList.remove('is-dragging');
      overlay.classList.remove('is-dragging');
      closeMegas(null);
      [].forEach.call(views.querySelectorAll('.mnav__view--sub.is-open'), function (v) { v.classList.remove('is-open'); });
      [].forEach.call(panel.querySelectorAll('[data-mnav-open]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
      sync();
      var main = views.querySelector('.mnav__view--root');
      if (main) main.scrollTop = 0;
    }

    toggle.addEventListener('click', function () { if (isOpen) close(); else open(); });
    overlay.addEventListener('click', function () { close(); });
    onMediaChange(function () { if (desktop.matches) close(true); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });

    panel.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-mnav-close]')) { close(); return; }
      var opener = t.closest('[data-mnav-open]');
      if (opener) {
        var view = doc.getElementById(opener.getAttribute('data-mnav-open'));
        if (!view) return;
        view.scrollTop = 0;
        view.classList.add('is-open');
        opener.setAttribute('aria-expanded', 'true');
        sync();
        focusQuietly(view.querySelector('[data-mnav-back]'));
        return;
      }
      var back = t.closest('[data-mnav-back]');
      if (back) {
        var sub = back.closest('.mnav__view--sub');
        sub.classList.remove('is-open');
        sync();
        var from = panel.querySelector('[data-mnav-open="' + sub.id + '"]');
        if (from) { from.setAttribute('aria-expanded', 'false'); focusQuietly(from); }
        return;
      }
      // Search: close the menu and open the header's search sheet (assets/predictive-search.js).
      if (t.closest('[data-mnav-search]')) {
        var search = doc.querySelector('.mobile-action-bar a[href*="search"]');
        if (!search) return;
        e.preventDefault();
        close(true);
        search.click();
        return;
      }
      var link = t.closest('a[href]');
      if (!link || link.classList.contains('js-gm-open') || link.hostname !== location.hostname || link.target === '_blank') return;
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      // A link to the page already open (an anchor on it) does not navigate; close so it shows.
      if (link.pathname === location.pathname) { close(true); return; }
      // Leaving the page: unpin it first, or the browser saves scroll position 0 for the Back button.
      body.style.top = '';
      root.classList.add('mnav-leaving');
      scrollPageTo(savedY);
    });

    doc.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = [].filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea'), function (el) {
        return el.getClientRects().length && getComputedStyle(el).visibility === 'visible';
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var i = items.indexOf(doc.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (i === -1 || i === items.length - 1)) { e.preventDefault(); first.focus(); }
    });

    /* Swipe left to close: the drawer follows the finger, a short flick or a third of its width closes it. */
    var startX = 0;
    var startY = 0;
    var startT = 0;
    var dx = 0;
    var mode = 0; // 0 undecided, 1 dragging the drawer, -1 a vertical scroll
    panel.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { mode = -1; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startT = e.timeStamp;
      dx = 0;
      mode = 0;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (mode === -1 || !isOpen) return;
      var x = e.touches[0].clientX - startX;
      var y = e.touches[0].clientY - startY;
      if (mode === 0) {
        if (Math.abs(x) < 12 && Math.abs(y) < 12) return;
        mode = x < 0 && Math.abs(x) > Math.abs(y) * 1.4 ? 1 : -1;
        if (mode === -1) return;
        panel.classList.add('is-dragging');
        overlay.classList.add('is-dragging');
      }
      e.preventDefault();
      dx = Math.min(0, x);
      panel.style.transform = 'translateX(' + dx + 'px)';
      overlay.style.opacity = String(Math.max(0, 1 + dx / panel.offsetWidth));
    }, { passive: false });
    function endSwipe(e) {
      if (mode !== 1) { mode = 0; return; }
      mode = 0;
      var fast = dx < -40 && e.timeStamp - startT < 250;
      panel.classList.remove('is-dragging');
      overlay.classList.remove('is-dragging');
      panel.style.transform = '';
      overlay.style.opacity = '';
      if (fast || dx < -panel.offsetWidth / 3) close();
    }
    panel.addEventListener('touchend', endSwipe);
    panel.addEventListener('touchcancel', endSwipe);

    return { views: views, sync: sync, close: close, isOpen: function () { return isOpen; } };
  }

  function initMega(gm) {
    var home = gm.parentNode;
    var toggle = home.querySelector('.site-nav__toggle');
    var trigger = home.querySelector('a.site-nav__link--main');
    var host = drawer ? drawer.views : null;
    var rail = gm.querySelector('.gm__rail');
    var railBack = gm.querySelector('.gm__rail > .gm__mhead [data-gm-close]');
    var openers = [].slice.call(doc.querySelectorAll('.js-gm-open[aria-controls="' + gm.id + '"]'));
    var cats = [].slice.call(gm.querySelectorAll('[data-gm-cat]'));
    var btns = cats.map(function (c) { return c.querySelector('.gm__cat-btn'); });
    var isOpen = false;
    var pinned = false;
    var opener = null;
    var openTimer = 0;
    var closeTimer = 0;
    var aimTimer = 0;
    var leaveTimer = 0;
    var track = [];

    function activeCat() {
      for (var i = 0; i < cats.length; i++) if (cats[i].classList.contains('is-active')) return cats[i];
      return cats[0];
    }
    function activate(cat) {
      clearTimeout(aimTimer);
      warm(cat);
      cats.forEach(function (c, i) {
        var on = c === cat;
        c.classList.toggle('is-active', on);
        btns[i].setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    function setTop(px) { gm.style.setProperty('--gm-top', Math.max(0, Math.round(px)) + 'px'); }
    // Thumbnails are loading="lazy" (13 panels x 11 images would be ~140 requests on
    // every page). Start a category's images once the reader is on the way to it.
    function warm(cat) {
      if (!cat || cat.hasAttribute('data-gm-warm')) return;
      cat.setAttribute('data-gm-warm', '');
      [].forEach.call(cat.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    }

    function show() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (isOpen) return;
      closeMegas(gm);
      isOpen = true;
      clearTimeout(leaveTimer);
      gm.classList.remove('gm-leaving');
      if (desktop.matches) {
        setTop(navBottom());
        home.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        root.classList.add('maw-gm-open');
      }
      gm.classList.add('is-open');
      if (drawer) drawer.sync();
    }
    function hide() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      clearTimeout(aimTimer);
      pinned = false;
      if (!isOpen) return;
      isOpen = false;
      gm.classList.remove('is-open', 'is-drilled');
      // Phones skip rendering a closed menu (mega-menu-styles); keep it drawn while it slides out.
      gm.classList.add('gm-leaving');
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () { gm.classList.remove('gm-leaving'); }, 320);
      home.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      if (!megas.some(function (m) { return m.panel !== gm && m.isOpen(); })) root.classList.remove('maw-gm-open');
      if (drawer) drawer.sync();
    }
    function focusActiveCat() {
      focusQuietly(btns[cats.indexOf(activeCat())]);
    }

    // Desktop keeps the panel inside its nav <li>; phones show it inside the menu drawer.
    function place() {
      hide();
      if (desktop.matches) {
        if (gm.parentNode !== home) home.appendChild(gm);
      } else if (host && gm.parentNode !== host) {
        host.appendChild(gm);
      }
    }
    place();
    onMediaChange(place);
    window.addEventListener('pageshow', function (e) { if (e.persisted) hide(); });

    openers.forEach(function (o) { o.addEventListener('pointerdown', function () { warm(activeCat()); }); });

    /* Desktop: mouse hover with intent delays */
    home.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !desktop.matches) return;
      warm(activeCat());
      clearTimeout(closeTimer);
      if (!isOpen) openTimer = setTimeout(show, 110);
    });
    home.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse' || !desktop.matches) return;
      clearTimeout(openTimer);
      if (isOpen && !pinned) closeTimer = setTimeout(hide, 90);
    });
    /* A page scroll carries the panel away from a still mouse, and Chrome only re-checks hover
       after the scroll settles, so a hover-opened panel closes on scroll instead of lingering. */
    window.addEventListener('scroll', function () {
      if (isOpen && !pinned && desktop.matches) hide();
    }, { passive: true });

    /* Desktop: the Guides link navigates to the hub, except the first tap on a touch screen */
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        if (!desktop.matches || !touchy() || isOpen) return;
        e.preventDefault();
        show();
        pinned = true;
      });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (isOpen && (pinned || touchy() || pointer === 'keyboard')) { hide(); return; }
        show();
        pinned = true;
        if (pointer === 'keyboard') focusActiveCat();
      });
      toggle.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        show();
        pinned = true;
        focusActiveCat();
      });
    }

    doc.addEventListener('pointerdown', function (e) {
      if (isOpen && desktop.matches && !home.contains(e.target)) hide();
    }, true);
    home.addEventListener('focusout', function (e) {
      if (isOpen && desktop.matches && e.relatedTarget && !home.contains(e.relatedTarget)) hide();
    });
    // Phones: Escape closes the whole drawer (initDrawer).
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen || !desktop.matches) return;
      var inside = gm.contains(doc.activeElement) || home.contains(doc.activeElement);
      hide();
      if (inside && toggle) toggle.focus();
    });

    /* Desktop: category rail. Menu aim: while the pointer is heading right toward the
       open panel, a category it merely crosses does not steal the panel. */
    gm.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      track.push([e.clientX, e.clientY, e.timeStamp]);
      if (track.length > 6) track.shift();
    }, true);
    function headingToPanel() {
      var now = track.length ? track[track.length - 1] : null;
      if (!now) return false;
      // Direction over the last ~120ms; after a rest, measure from the resting point.
      var from = track.length > 1 ? track[track.length - 2] : null;
      for (var i = 0; i < track.length - 1; i++) {
        if (now[2] - track[i][2] <= 120) { from = track[i]; break; }
      }
      if (!from) return false;
      var panel = activeCat().querySelector('.gm__panel').getBoundingClientRect();
      var dx = now[0] - from[0];
      if (dx <= 0 || now[0] >= panel.left || panel.left <= from[0]) return false;
      var slope = (now[1] - from[1]) / dx;
      var toTop = (panel.top - from[1]) / (panel.left - from[0]);
      var toBottom = (panel.bottom - from[1]) / (panel.left - from[0]);
      return slope > toTop && slope < toBottom;
    }

    btns.forEach(function (btn, i) {
      var cat = cats[i];
      btn.addEventListener('click', function () {
        activate(cat);
        if (!desktop.matches) drill(cat);
      });
      btn.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !desktop.matches || cat.classList.contains('is-active')) return;
        clearTimeout(aimTimer);
        if (headingToPanel()) aimTimer = setTimeout(function () { activate(cat); }, 170);
        else activate(cat);
      });
      btn.addEventListener('pointerenter', function () { warm(cat); });
      btn.addEventListener('pointerleave', function () { clearTimeout(aimTimer); });
      btn.addEventListener('keydown', function (e) {
        var k = e.key;
        var j = -1;
        if (k === 'ArrowDown') j = (i + 1) % btns.length;
        else if (k === 'ArrowUp') j = (i - 1 + btns.length) % btns.length;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = btns.length - 1;
        else if (k === 'ArrowRight' && desktop.matches) {
          activate(cat);
          var first = cat.querySelector('.gm__panel a');
          if (first) { e.preventDefault(); first.focus(); }
          return;
        }
        if (j < 0) return;
        e.preventDefault();
        btns[j].focus();
        if (desktop.matches) activate(cats[j]);
      });
      cat.querySelector('.gm__panel').addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' && desktop.matches) { e.preventDefault(); btn.focus(); }
      });
    });

    /* Phones: menu -> category panels inside the drawer. Only a drilled-into category is "expanded". */
    function collapseCats() {
      btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    function drill(cat) {
      var panel = cat.querySelector('.gm__panel');
      panel.scrollTop = 0;
      gm.classList.add('is-drilled');
      focusQuietly(panel.querySelector('[data-gm-back]'));
    }
    gm.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-gm-back]')) {
        gm.classList.remove('is-drilled');
        collapseCats();
        focusActiveCat();
      } else if (e.target.closest('[data-gm-close]')) {
        hide();
        focusQuietly(opener);
      }
    });
    openers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (desktop.matches) return;
        e.preventDefault();
        opener = o;
        gm.classList.remove('is-drilled');
        collapseCats();
        // Each category's large "Most popular" photo, so it is there when the panel slides in.
        [].forEach.call(gm.querySelectorAll('.gm__feature img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
        show();
        // After show(): a closed menu is not rendered, so its scroll position cannot be reset.
        if (rail) rail.scrollTop = 0;
        o.setAttribute('aria-expanded', 'true');
        focusQuietly(railBack);
      });
    });

    return { panel: gm, hide: hide, isOpen: function () { return isOpen; } };
  }
})();
